import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import { IconInstagram } from './Icons';
import styles from './Footer.module.css';

export default function Footer() {
  const { data } = useSite();
  const navigate = useNavigate();
  const location = useLocation();
  const [showPrivacy, setShowPrivacy] = useState(false);

  const goTo = (path) => navigate(path);

  const scrollTo = (id) => {
    if (location.pathname === '/') {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };

  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.footerGrid}>

          {/* ─── Brand ─── */}
          <div>
            <div className={styles.footerLogo}>
              <div className={styles.footerLogoIcon}>
                <img src="/keepers-logo.png" alt="Keepers" />
              </div>
              <span className={styles.footerLogoText}>Keepers Experience</span>
            </div>
            <p className={styles.footerAbout}>
              Your experience experts in Jordan. Weekly hikes, private trips & corporate team-building with a focus on nature and authentic Jordanian landscapes.
            </p>
            <a
              href={data.contact.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className={styles.footerSocial}
            >
              <IconInstagram size={18} />
            </a>
          </div>

          {/* ─── Quick Links ─── */}
          <div>
            <div className={styles.footerTitle}>Quick Links</div>
            <button className={styles.footerLink} onClick={() => goTo('/')}>Home</button>
            <button className={styles.footerLink} onClick={() => goTo('/trips')}>All Trips</button>
            <button className={styles.footerLink} onClick={() => goTo('/corporate')}>Corporate</button>
            <button className={styles.footerLink} onClick={() => goTo('/blog')}>Blog</button>
            <button className={styles.footerLink} onClick={() => goTo('/experiences')}>Experiences</button>
            <button className={styles.footerLink} onClick={() => scrollTo('about')}>About Us</button>
            <button className={styles.footerLink} onClick={() => scrollTo('contact')}>Contact</button>
            <button className={styles.footerLink} onClick={() => setShowPrivacy(true)}>Privacy Policy</button>
          </div>

          {/* ─── Trip Types ─── */}
          <div>
            <div className={styles.footerTitle}>Trip Types</div>
            {['Hiking Trails', 'Night Walks', 'Private Tours', 'Corporate Events', 'Ramadan Specials'].map(s => (
              <div key={s} className={styles.footerLink}>{s}</div>
            ))}
          </div>

        </div>

        <div className={styles.footerBottom}>
          <span>© {new Date().getFullYear()} Keepers Experience الحراس. All rights reserved.</span>
          <span>
            Powered by{' '}
            <a href="https://applumo.com" target="_blank" rel="noreferrer" className={styles.poweredLink}>
              Applumo.com
            </a>
          </span>
        </div>
      </footer>

      {showPrivacy && <PrivacyPolicyModal onClose={() => setShowPrivacy(false)} />}
    </>
  );
}
